import classNames from 'classnames';
import React, { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    tooltipText?: string;
    errorText?: string;
    infoLinkLabel?: string;
    infoLinkText?: string;
    modalHelpBody?: string;
    modalHelpHeader?: string;
}

const Input = ({ label, id, errorText, type, onChange, ...rest }: InputProps): JSX.Element => {
    return (
        <div className={classNames('form-group', { 'required-name': errorText })}>
            {label && <label htmlFor={id}>{label}</label>}
            <input id={id} type={type} className="form-control" onChange={onChange} {...rest} />
            <div className="required-warning">{errorText}</div>
        </div>
    );
};

export default Input;
